<template>
    <div class="w-100">
        <template
            v-for="section in ruleSections"
            v-bind:key="`rules_${section.ruleType}`">
            <span v-bind:class="{ 'cpadmin-text': shouldAddCpAdminClass(section.ruleType) }">
                <slot
                    name="header"
                    v-bind:rule-type="section.ruleType"
                    v-bind:header="section.header"
                    v-bind:help-text="section.helpText" />
            </span>
            <rule-table
                v-bind:rules="section.rules"
                v-bind:rule-type="section.ruleType"
                v-bind:editable="editable && canEditRuleType(section.ruleType)" />
        </template>
    </div>
</template>

<script>
    import ruleTable from "./ruleTable.vue";
    import { KEYS, NAMESPACE } from "./i18n/automationRules.i18n";
    import { mapI18n } from "Util/i18n";
    import { RULE_TYPE, TRIGGER_TYPE } from "Types/automationTypes";
    import { EDIT_AUTOMATION_TYPES } from "Automations/editAutomation/editAutomationStore";

    export default {
        components: {
            ruleTable
        },
        props: {
            automation: { type: Object, required: true },
            editable: { type: Boolean, required: false, default: false }
        },
        computed: {
            ruleSections() {
                const triggerType = this.automation.Trigger.Type;
                const sections = [];

                if (triggerType === TRIGGER_TYPE.Scheduled) {
                    if (this.isCPAdmin) {
                        sections.push({
                            header: this[KEYS.ProgramWideProjectRulesSectionHeader],
                            ruleType: RULE_TYPE.programWideProject,
                            rules: this.automation.ActionRules
                        });
                    }

                    sections.push({
                        header: this[KEYS.ProgramWideActionRulesSectionHeader],
                        helpText: this[KEYS.ActionRulesSectionHelpText],
                        ruleType: RULE_TYPE.program,
                        rules: this.automation.ProgramRules
                    });

                    return sections;
                }

                const skipValidationForTriggers = [TRIGGER_TYPE.Inquiry, TRIGGER_TYPE.ESignatureEnvelope];

                if (!skipValidationForTriggers.includes(triggerType)) {
                    sections.push({
                        header: this[KEYS.ValidationRulesSectionHeader],
                        helpText: this.getValidationRuleHelpText(triggerType),
                        ruleType: RULE_TYPE.validation,
                        rules: this.automation.ValidationRules
                    });
                }

                sections.push({
                    header: this[KEYS.ActionRulesSectionHeader],
                    helpText: this[KEYS.ActionRulesSectionHelpText],
                    ruleType: RULE_TYPE.action,
                    rules: this.automation.ActionRules
                });

                return sections;
            },
            isCPAdmin() {
                return this.$app.loggedInUserIsCPAdmin;
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            canEditRuleType(ruleType) {
                return this.$store.getters[EDIT_AUTOMATION_TYPES.getters.canEditRuleType](ruleType);
            },
            getValidationRuleHelpText(ruleType) {
                switch (ruleType) {
                    case TRIGGER_TYPE.Form:
                        return this[KEYS.FormValidationRulesSectionHelpText];
                    case TRIGGER_TYPE.Status:
                        return this[KEYS.StatusValidationRulesSectionHelpText];
                    default:
                        return this[KEYS.GenericValidationRulesSectionHelpText];
                }
            },
            shouldAddCpAdminClass(ruleType) {
                return ruleType === RULE_TYPE.programWideProject;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .cpadmin-text {
        color: var(--pc-cp-admin-color);
    }
</style>
